import { render, staticRenderFns } from "./BuscarVerificacionyDetalle.vue?vue&type=template&id=597135d9&scoped=true"
import script from "./BuscarVerificacionyDetalle.vue?vue&type=script&lang=js"
export * from "./BuscarVerificacionyDetalle.vue?vue&type=script&lang=js"
import style0 from "./BuscarVerificacionyDetalle.vue?vue&type=style&index=0&id=597135d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597135d9",
  null
  
)

export default component.exports